<app-mobile-header [title]="title"></app-mobile-header>
<div class="row">
    <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3 mt-2">
  @if(showError) {
    <div class="row">
      <div class="col-12">
        <div class="alert alert-danger text-center" role="alert">
          {{ errorMessage | translate }}
        </div>
      </div>
    </div>
  }
  @if(sessionInfo) {
    @if(sessionInfo.isClosed) {
      <app-fast-checkin-session-closed [sessionInfo]="sessionInfo" (downloadReceipt)="onDownloadReceipt()"></app-fast-checkin-session-closed>
    } @else if(sessionInfo.visitorSessionIdToValidate && !sessionInfo.validatedByParkingCard) {
      <app-fast-checkin-session-visitor-activation [sessionInfo]="sessionInfo" (checkOut)="onCheckOut()" (validateParkingCard)="onValidateParkingCard($event)"></app-fast-checkin-session-visitor-activation>
    } @else {
      <app-fast-checkin-session-active
        [sessionInfo]="sessionInfo"
        [extensionPriceWithCurrency]="extensionPriceWithCurrency"
        [isExtensionPriceLoading]="isExtensionPriceLoading"
        (checkOut)="onCheckOut()"
        (extensionDurationChanged)="onExtensionDurationChanged($event)"
        (extendSession)="onExtendSession($event)"></app-fast-checkin-session-active>
    }
  }
  </div>
</div>

